var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import { NetworkError, NetworkUnreachable } from './UhstErrors';
var REQUEST_OPTIONS = {
  method: 'POST'
};

var getRequestOptions = function getRequestOptions(body) {
  if (body) {
    return __assign(__assign({}, REQUEST_OPTIONS), {
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });
  } else {
    return REQUEST_OPTIONS;
  }
};

var NetworkClient = function () {
  function NetworkClient() {}

  NetworkClient.prototype.post = function (url, queryParams, body, timeout) {
    return __awaiter(this, void 0, void 0, function () {
      var response, _a, error_1;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (queryParams && queryParams.length > 0) {
              url = url + "?" + queryParams.join('&');
            }

            _b.label = 1;

          case 1:
            _b.trys.push([1, 6,, 7]);

            if (!timeout) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , this.fetchWithTimeout(url, __assign(__assign({}, getRequestOptions(body)), {
              timeout: timeout
            }))];

          case 2:
            _a = _b.sent();
            return [3
            /*break*/
            , 5];

          case 3:
            return [4
            /*yield*/
            , fetch(url, getRequestOptions(body))];

          case 4:
            _a = _b.sent();
            _b.label = 5;

          case 5:
            response = _a;
            return [3
            /*break*/
            , 7];

          case 6:
            error_1 = _b.sent();
            throw new NetworkUnreachable(error_1);

          case 7:
            if (response.status == 200) {
              return [2
              /*return*/
              , response.json()];
            } else {
              throw new NetworkError(response.status, "" + response.statusText);
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  NetworkClient.prototype.get = function (url, queryParams, timeout) {
    return __awaiter(this, void 0, void 0, function () {
      var response, _a, error_2;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (queryParams && queryParams.length > 0) {
              url = url + "?" + queryParams.join('&');
            }

            _b.label = 1;

          case 1:
            _b.trys.push([1, 6,, 7]);

            if (!timeout) return [3
            /*break*/
            , 3];
            return [4
            /*yield*/
            , this.fetchWithTimeout(url, {
              timeout: timeout
            })];

          case 2:
            _a = _b.sent();
            return [3
            /*break*/
            , 5];

          case 3:
            return [4
            /*yield*/
            , fetch(url)];

          case 4:
            _a = _b.sent();
            _b.label = 5;

          case 5:
            response = _a;
            return [3
            /*break*/
            , 7];

          case 6:
            error_2 = _b.sent();
            throw new NetworkUnreachable(error_2);

          case 7:
            if (response.status == 200) {
              return [2
              /*return*/
              , response.json()];
            } else {
              throw new NetworkError(response.status, "" + response.statusText);
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  NetworkClient.prototype.fetchWithTimeout = function (resource, options) {
    return __awaiter(this, void 0, void 0, function () {
      var _a, timeout, controller, id, response;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _a = options.timeout, timeout = _a === void 0 ? 8000 : _a;
            controller = new AbortController();
            id = setTimeout(function () {
              return controller.abort();
            }, timeout);
            return [4
            /*yield*/
            , fetch(resource, __assign(__assign({}, options), {
              signal: controller.signal
            }))];

          case 1:
            response = _b.sent();
            clearTimeout(id);
            return [2
            /*return*/
            , response];
        }
      });
    });
  };

  return NetworkClient;
}();

export { NetworkClient };